const StreamsService = {
  getStreams: async () => {
    const { data } = await ovpFetch('/live/stream');
    return data;
  },
  createStream: async (payload) => {
    await ovpFetch('/live/stream', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return true;
  },
  removeStream: async (id) => {
    await ovpFetch(`/live/stream/${id}`, {
      method: 'DELETE',
    });
    return true;
  },
  getMetrics: async ({
    id,
    start,
    end,
    step = 30,
  }) => {
    const { data } = await ovpFetch(`/live/stream/${id}/metrics?start=${start}&end=${end}&step=${step}`);
    return data;
  },
  getDeviceCPU: async (id, dates, step = 30) => {
    const { data } = await ovpFetch(`/live/broadcast/${id}/metrics/device/cpu?start=${dates.start}&end=${dates.end}&step=${step}`);
    return data;
  },
  getDeviceBattery: async (id, dates, step = 30) => {
    const { data } = await ovpFetch(`/live/broadcast/${id}/metrics/device/battery?start=${dates.start}&end=${dates.end}&step=${step}`);
    return data;
  },
};

// eslint-disable-next-line
export { StreamsService };
